// extracted by mini-css-extract-plugin
module.exports = {"finPlatform":"FinPlatform_finPlatform__IPaKj","link":"FinPlatform_link__pltBT","block":"FinPlatform_block__bylZu","card":"FinPlatform_card__sWf3p"};